export default "__VITE_ASSET__BRbuoJgq__"